module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCond-Italic.9ff1d2fd.ttf";